import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { environment } from "src/environments/environment";

interface ApiResponse<T> {
    success: boolean;
    data?: T;
    message?: string;
}

export interface SupportRequestDto {
    id: number | null;
    topic: string;
    issueDescription: string;
    issue_description?: string;
}

export interface CreateSupportRequestPayload {
    topic: string;
    issueDescription: string;
    userIssueDescription?: string;
    requestType?: "support" | "feedback";
}

@Injectable({ providedIn: "root" })
export class SupportRequestsService {
    private readonly apiBaseUrl = environment.baseurl.replace(/\/$/, "");

    constructor(private readonly http: HttpClient) {}

    createSupportRequest(payload: CreateSupportRequestPayload): Observable<SupportRequestDto> {
        const topic = typeof payload.topic === "string" ? payload.topic.trim() : "";
        const issueDescription = typeof payload.issueDescription === "string" ? payload.issueDescription : "";
        const userIssueDescription = typeof payload.userIssueDescription === "string" ? payload.userIssueDescription : undefined;
        const requestType = payload.requestType === "feedback" ? "feedback" : payload.requestType === "support" ? "support" : undefined;

        const body = {
            topic,
            issueDescription,
            userIssueDescription,
            requestType
        };

        return this.http
            .post<ApiResponse<SupportRequestDto>>(`${this.apiBaseUrl}/support-requests`, body)
            .pipe(
                map((response) => {
                    if (!response?.success || !response.data) {
                        throw new Error(response?.message || "We couldn't submit your support request. Please try again.");
                    }

                    const data = response.data;
                    return {
                        id: data.id ?? null,
                        topic: data.topic ?? topic,
                        issueDescription: data.issueDescription ?? data.issue_description ?? issueDescription
                    };
                })
            );
    }
}
